<template>
  <div class='report-item report-item--imagebox brand-background-color' :style='styleOptions'>
    <div :class="['image-container', content.image ? 'with-image': 'without-image']">
      <div class="placeholder"><ion-icon name="image-outline"></ion-icon></div>
      <img class='content-image' :src="content.image" alt="">
    </div>

    <UIActions v-if='editable' :buttons='buttons' @delete='onDelete' @add='onAdd' @edit='onEdit'></UIActions>
  </div>
</template>
<script>
import UIActions from './UIActions.vue'
import ContentEditable from '../../ContentEditable.vue'
import Button from './Button.vue'
import _ from 'lodash';
export default {
  props: {
    'config': {default: ()=>{{}}, type: Object},
    'editable': {default: true, type: Boolean},
    'report': {default: ()=>{{}}, type: Object},
    'response': {default: ()=>{{}}, type: Object},
    'buttons': {default: ()=>{['edit', 'add', 'delete']}, type: Array}
  },
  data () {
    return {
      content: {},
      ready: false
    }
  },
  components: {
    UIActions,
    ContentEditable,
    Button
  },
  methods: {
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'ImageEditPanel'})
    },
    onCTAEdit (event) {
      this.$emit('edit', event)
    },
    onAdd () {
      this.$emit('add')
    },
    onDelete () {
      this.$emit('delete')
    }
  },
  computed: {
    titleStyles () {
      return {
        color: this.config.theme.color
      }
    },
    styleOptions () {
      let themeOptions = {
      }
      if (this.config.image){

      }
      return {
        ...themeOptions,
        ...this.config.theme
      }
    }
  },
  created () {
    this.content = this.config
    setTimeout(()=>{this.ready = true}, 500)
    this.save = _.debounce(function(){
      if (!this.editable) {
        return
      }
      this.$store.dispatch('saveItem', this.config)
    }, 500)
  },
  watch: {
    content: {
      handler: function(content){
        if(!this.ready){
          this.ready = true
          return
        }
        this.$store.commit('setDirty', true)
        this.save()
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
  @import '../../../../scss/components/variables';
  @import '../../../../scss/components/form';
  @import '../scss/report_items';
  #report-view .report {

  }
  .report-item--imagebox {
    min-height: 0;
    .ui-actions {
      z-index: 2;
    }
    .with-image {
      .placeholder {
        display: none;
      }
    }
    .without-image {
      .placeholder {
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        ion-icon {
          font-size: 80px;
          color: #dedede;
        }
      }
    }
  }
  .content-image {
    width: 100%;
    display: block;
  }
  @media screen and (min-width: 768px) {
    .report-item--imagebox .without-image .placeholder {
      min-height: 300px;
    }
  }
  @media screen and (min-width: 920px) {
    .report-item--imagebox .without-image .placeholder {
      min-height: 400px;
    }
  }
</style>